import $ from 'jquery'

window.addEventListener('DOMContentLoaded', function () {
    const ktable = $("#torschuetzen").ktable().data('ktable');
    ktable.stack(["spieler", "mannschaft"]);
    ktable.hide(["elfmeter"]);
    ktable.shrink(["spieler"]);
    ktable.wrap(["spieler"]);
    ktable.init();
});
